/*
 * @Date: 2023-02-24 10:07:14
 * @LastEditTime: 2023-07-14 10:36:26
 */
import { request } from '@/request/request';

export default {
  // 学生成绩查询
  getStudentScore(data) {
    return request({
      url: '/score-record/getStudentScore',
      method: 'get',
    });
  },

  // 学生市赛成绩查询
  getPastStudentScore(data) {
    return request({
      url: '/score-record/getPastStudentScore',
      method: 'get',
    });
  },

// 学生过往成绩查询
  getPastScore(data) {
  return request({
    url: '/score-record/getPastScore',
    method: 'get',
  });
},
};
